var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox lucky-wheel-record" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "page-title" }, [_vm._v("抽奖记录")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-wrap" },
            [
              _c(
                "el-input",
                {
                  staticClass: "keyword-input",
                  attrs: {
                    placeholder: "记录编号 / 用户ID / 手机号",
                    size: "small",
                    clearable: "",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearch($event)
                    },
                  },
                  model: {
                    value: _vm.query.keyword,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "keyword", $$v)
                    },
                    expression: "query.keyword",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm.handleSearch },
                    slot: "append",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "filter-select",
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "全部奖项类型",
                  },
                  model: {
                    value: _vm.query.prizeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "prizeType", $$v)
                    },
                    expression: "query.prizeType",
                  },
                },
                _vm._l(_vm.prizeTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "filter-select-sm",
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "全部结果",
                  },
                  model: {
                    value: _vm.query.result,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "result", $$v)
                    },
                    expression: "query.result",
                  },
                },
                _vm._l(_vm.resultOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "filter-select",
                  attrs: {
                    size: "small",
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchCustomerOptions,
                    loading: _vm.customerLoading,
                    placeholder: "全部来源小程序",
                  },
                  model: {
                    value: _vm.query.customerId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "customerId", $$v)
                    },
                    expression: "query.customerId",
                  },
                },
                _vm._l(_vm.customerOptions, function (item) {
                  return _c("el-option", {
                    key: item.customerId,
                    attrs: { label: item.appName, value: item.customerId },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "filter-select",
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "全部奖品状态",
                  },
                  model: {
                    value: _vm.query.prizeStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "prizeStatus", $$v)
                    },
                    expression: "query.prizeStatus",
                  },
                },
                _vm._l(_vm.prizeStatusOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleReset } },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "record-table",
              attrs: {
                data: _vm.tableData,
                size: "small",
                border: "",
                "highlight-current-row": "",
                "header-cell-style": {
                  fontWeight: "bold",
                  background: "#f5f7fa",
                  color: "#606266",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "recordNo",
                  label: "记录编号",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "uid",
                  label: "用户ID",
                  "min-width": "110",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "手机号",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "activityName",
                  label: "活动名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "drawTime",
                  label: "抽奖时间",
                  "min-width": "170",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "结果", "min-width": "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                Number(scope.row.result) === 1
                                  ? "success"
                                  : "info",
                              size: "small",
                              effect: "plain",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.resultDesc || "—") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "prizeTypeDesc",
                  label: "奖项类型",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "奖项内容", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "prize-content" },
                          _vm._l(
                            _vm.prizeContentLines(scope.row),
                            function (line, idx) {
                              return _c("div", { key: idx }, [
                                _vm._v(_vm._s(line)),
                              ])
                            }
                          ),
                          0
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "奖品状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.prizeStatusTagType(
                                scope.row.prizeStatus
                              ),
                              size: "small",
                              effect: "plain",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.prizeStatusDesc || "—") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "来源小程序",
                  "min-width": "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.sourceAppName
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "small",
                                  type: "info",
                                  effect: "plain",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.sourceAppName))]
                            )
                          : _c("span", [_vm._v("—")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("template", { slot: "empty" }, [
                _c("span", { staticClass: "el-table__empty-text" }, [
                  _vm._v("暂无数据"),
                ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm.total > 0
            ? _c(
                "div",
                { staticClass: "table-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageData.page,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageData.limit,
                      layout: "total, sizes, prev, pager, next",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handlePageChange,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }